import './AssignPublishedVersionNameModal.scss';
class AssignPublishedVersionNameModalController {
    static $inject = ['title', 'description', 'close', 'confirm'];
    constructor(title, description, close, confirm) {
        this.title = title;
        this.description = description;
        this.close = close;
        this.confirm = confirm;
        this.isProcessing = false;
        this.isProccessFail = false;
        this.onTitleChange = (event) => {
            this.title = event.detail.value;
        };
        this.onDescriptionChange = (event) => {
            this.description = event.detail.value;
        };
        this._close = this.close;
    }
    async $onInit() {
        this.addEvents();
    }
    addEvents() {
        const modal = document.querySelector('#assign-published-version-name-modal');
        modal.addEventListener('bdsModalChanged', e => { modal.remove(); });
        document.getElementById('assign-published-version-name-modal-title').addEventListener('bdsChange', (e) => { this.onTitleChange(e); });
        document.getElementById('assign-published-version-name-modal-description').addEventListener('bdsChange', (e) => { this.onDescriptionChange(e); });
    }
    async _confirm() {
        this.isProccessFail = false;
        try {
            await this.confirm(this.title, this.description);
            this._close();
        }
        catch (e) {
            this.isProccessFail = true;
        }
    }
    async cancel() {
        this._close();
    }
}
AssignPublishedVersionNameModalController.$inject = ['title', 'description', 'close', 'confirm'];
export default AssignPublishedVersionNameModalController;
